import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { IbnProtokoll } from '../Models/ibn-protokoll.model';

/**
 * Datenbasis für den PDF-Export eines IBN-Protokolls.
 *
 * Der Server wertet aus, der Client formatiert: eine Anfrage liefert alles,
 * was im PDF steht – auch bei einem Projekt mit mehreren Inbetriebnahmen.
 */
@Injectable({ providedIn: 'root' })
export class IbnProtokollService {
  private baseUrl = environment.apiBaseUrl + '/ibnprotokoll';

  constructor(private http: HttpClient) { }

  /** Protokoll über ein ganzes Projekt mit allen Inbetriebnahmen. */
  getProjektProtokoll(projektId: number): Observable<IbnProtokoll> {
    return this.http.get<IbnProtokoll>(`${this.baseUrl}/projekt/${projektId}`);
  }

  /** Protokoll über eine Inbetriebnahme (= eine Messstellenliste). */
  getInbetriebnahmeProtokoll(listeId: number): Observable<IbnProtokoll> {
    return this.http.get<IbnProtokoll>(`${this.baseUrl}/inbetriebnahme/${listeId}`);
  }

  /** Protokoll über eine einzelne Messstelle, inklusive Prüfverlauf. */
  getMessstelleProtokoll(messstelleId: number): Observable<IbnProtokoll> {
    return this.http.get<IbnProtokoll>(`${this.baseUrl}/messstelle/${messstelleId}`);
  }
}
